export const popupsArr = [
  { text: 'Зацепки могут быть разные. Дата и время создания файла, никнейм автора, версия и технические характеристики программы или устройства и даже отметка местоположения.' },
  { text: 'Это все метаданные – дополнительная информация о файле, которая автоматически сохраняется системой при его создании и изменении.' },
  { text: 'Хакеры оставляют улики по невнимательности, а иногда специально, чтобы запутать следы.' },
  { text: 'Давай заглянем внутрь вируса и попробуем найти эти улики!', buttonTitle: 'Открыть вирус' },
]
